module.exports = __webpack_public_path__ + "img/pt-box4-text-light.6f148ce5.png";